import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SideMenuRightComponent } from './side-menu-right.component';
import { ContextService } from './context.service';


@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [SideMenuRightComponent],
  exports: [
    SideMenuRightComponent
  ],
  providers: [ContextService]
})
export class SideMenuRightModule { }
